import { useMemo } from "react";
import styles from "../WorkoutAdminModal.module.css";

const byName = (a, b) => (a.name || "").localeCompare(b.name || "", "pt-BR", { sensitivity: "base" });

// Agrupa as opções: exercícios do próprio professor primeiro, depois os da
// plataforma. Admin (que vê o catálogo de todos) ganha um terceiro grupo com
// os exercícios cadastrados por professores. Cada grupo em ordem alfabética,
// sem diferenciar maiúsculas ("AFUNDO NO SMITH" junto de "Afundo com Halter").
export function groupExerciseItems(items, ownerId) {
  const own = [], platform = [], others = [];
  for (const item of items) {
    if (ownerId != null && item.professor_id === ownerId) own.push(item);
    else if (item.professor_id == null) platform.push(item);
    else others.push(item);
  }
  return [
    { label: "Seus exercícios", items: own.sort(byName) },
    { label: "Plataforma", items: platform.sort(byName) },
    { label: "Exercícios de professores", items: others.sort(byName) },
  ].filter((g) => g.items.length > 0);
}

// Select de exercício na prescrição (treino-modelo e exercício avulso do
// aluno) com o botão "Ver vídeo" ao lado: o professor confere a execução
// antes de incluir o exercício. `demoUrlFor` resolve o vídeo que o aluno vai
// ver (o próprio do professor, se houver, senão o padrão do catálogo) e
// `onPreview` abre o ExerciseDemoModal por cima do modal de prescrição.
export default function ExerciseSelectWithPreview({ id, value, onChange, items, demoUrlFor, onPreview, ownerId }) {
  const selected = items.find((it) => String(it.id) === String(value));
  const groups = useMemo(() => groupExerciseItems(items, ownerId), [items, ownerId]);
  const hasVideo = !!(selected && demoUrlFor(selected));

  return (
    <div className={styles.exerciseSelectRow}>
      <select id={id} value={value} onChange={onChange} required>
        <option value="">Selecione</option>
        {groups.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.items.map((item) => (
              <option key={item.id} value={item.id}>{item.name}</option>
            ))}
          </optgroup>
        ))}
      </select>
      {hasVideo && (
        <button
          type="button"
          className={`${styles.wamBtn} ${styles.ghost} ${styles.exercisePreviewBtn}`}
          onClick={() => onPreview(selected)}
          aria-label={`Ver vídeo de demonstração de ${selected.name}`}
          title="Ver vídeo de demonstração"
        >
          ▶ Ver vídeo
        </button>
      )}
    </div>
  );
}
